<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">
                <i class="fas fa-gavel"></i>
                Lot #</label>
        </div>
        <div class="field-body">
            <div class="field">
                <p class="control">
                    <multi-select v-model="lots"
                                  :close-on-select="false"
                                  :options="existingLots"
                                  :multiple="true"
                                  placeholder="Type lot number"
                                  :taggable="true"
                                  @tag="addLot"
                                  @remove="removeLot">
                    </multi-select>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import MultiSelect from 'vue-multiselect';
    export default {
        components: {
            MultiSelect
        },
        data () {
            return {
                existingLots: []
            }
        },
        computed: {
            lots: {
                get: function () {
                    return this.$store.getters.getQueryLotsStock
                },
                set: function () {

                }
            }
        },
        methods: {
            addLot(value) {
                this.$store.dispatch('handleQueryLotsStock', value)
            },
            removeLot(value) {
                this.$store.dispatch('removeLotFromQueryStock', value)
            }
        }
    }
</script>


<style scoped>
    input:focus {
        outline:none;
    }
    .tags-input input{
        height: 100% !important;
        width: 250px !important;
        border-style: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/StockCars/LotNumberInputStockCar.vue